// @Imports from toolkit
import { createSlice } from "@reduxjs/toolkit";
import {
  getTokenCookie,
  getUserCookie,
  removeAll,
  setTokenCookie,
  setUserCookie,
} from "../../../utils/storage";
import {
  getCurrentUserAction,
  logoutAction,
  signInAction,
  signUpAction,
} from "./authActions";

// @Initial state
const initialState = {
  loading: false,
  user: getUserCookie(),
  token: getTokenCookie(),
  error: "",
};

// @Slice
export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(signInAction.rejected, (state, action) => {
      const { code, message } = action.error;
      let msg = message;
      if (code === "auth/user-not-found") {
        msg = "Invalid credentials.";
      } else if (code === "auth/invalid-email") {
        msg = "Invalid email or Password";
      } else if (code === "auth/wrong-password") {
        msg = "Invalid credentials.";
      }
      state.error = msg;
      state.loading = false;
    });
    builder

      .addCase(signInAction.fulfilled, (state, action) => {
        if (action?.payload?.role?.slug === "super_admin") {
          state.user = action.payload;
          state.token = action.payload.accessToken;
          state.loading = false;
          setUserCookie(action.payload);
          setTokenCookie(action.payload.accessToken);
        } else {
          state.error = "You are restricted to Login !";
          state.loading = false;
        }
      })

      .addCase(signInAction.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCurrentUserAction.fulfilled, (state, action) => {
        state.user = action.payload;
        setUserCookie(action.payload);
      })
      .addCase(logoutAction.fulfilled, (state) => {
        removeAll();
        state.user = null;
        state.token = null;
        state.assignedProperties = [];
      });
  },
});
export default authSlice.reducer;
export const {} = authSlice.actions;
